import React from 'react';
import { Spinner } from 'react-bootstrap';
import '../styles/Loader.css';

export const FullPageLoader = () => {
  return (
    <div className="full-page-loader">
      <Spinner animation="border" variant="primary" />
      <p className="mt-3">Loading...</p>
    </div>
  );
};

export const Loader = ({ size = 'md', variant = 'primary' }) => {
  return (
    <div className="text-center py-3">
      <Spinner animation="border" variant={variant} size={size} />
    </div>
  );
};

export const SkeletonLoader = ({ count = 1, height = 50 }) => {
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <div key={index} className="skeleton-loader mb-3" style={{ height: `${height}px` }} />
      ))}
    </>
  );
};

export default Loader;